module.exports = __webpack_public_path__ + "img/img07.7ec98a7e.jpg";